import { HeroCTA } from '../HeroCTA'
import { HeroDesktopDualImageTiles } from './HeroDesktopDualImageTiles'
import { HeroDesktopSingleImageTile } from './HeroDesktopSingleImageTile'

export const HeroDesktop = ({
  heading,
  subheading,
  img1Url,
  img1Alt = '',
  img2Url,
  img2Alt = '',
}: {
  heading: string
  subheading: string
  img1Url: string
  img1Alt?: string
  img2Url?: string
  img2Alt?: string
}) => (
  <section
    className='container d-none d-lg-flex mc-mt-6'
    style={{ position: 'relative' }}
  >
    <div
      className='row mc-mt-10'
      style={{
        zIndex: 1,
      }}
    >
      <div className='col-8'>
        <h1 className='mc-mb-5 mc-text-d3 mc-text--brand mc-text--uppercase mc-text--left'>
          {heading}
        </h1>
        <p className='mc-text-h4 mc-mb-8'>{subheading}</p>
        <div className='col-7'>
          <HeroCTA outcomeName={heading} />
        </div>
      </div>
    </div>
    <div
      className='row d-flex'
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 0,
      }}
    >
      {img1Url && img2Url ? (
        <HeroDesktopDualImageTiles
          img1Url={img1Url}
          img1Alt={img1Alt}
          img2Url={img2Url}
          img2Alt={img2Alt}
        />
      ) : (
        <HeroDesktopSingleImageTile imgUrl={img1Url} imgAlt={img1Alt} />
      )}
    </div>
  </section>
)
